import Axios from 'axios';

class KindsService {
  getGroups() {
    return Axios.get('/admin/kinds', {
      params: {
        only_groups: true,
        only_members: false,
      },
    })
      .then(({ data }) => data);
  }

  getMembers() {
    return Axios.get('/admin/kinds', {
      params: {
        only_groups: false,
        only_members: true,
      },
    })
      .then(({ data }) => data);
  }

  getAll() {
    return Axios.get('/admin/kinds')
      .then(({ data }) => data);
  }
}

export default new KindsService();
